var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyportfoliodesigncopy07(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#1A1A1A;}\n\t.st2{fill:#FED631;}\n\t.st3{fill:#FFFFFF;stroke:#1A1A1A;stroke-width:17;stroke-miterlimit:10;}\n\t.st4{fill:#FED631;stroke:#1A1A1A;stroke-width:12;stroke-miterlimit:10;}\n\t.st5{fill:#FED631;stroke:#1A1A1A;stroke-width:4;stroke-miterlimit:10;}\n\t.st6{fill:#1A1A1A;stroke:#1A1A1A;stroke-width:2;stroke-miterlimit:10;}\n\t.st7{fill:#FED631;stroke:#212121;stroke-width:12;stroke-miterlimit:10;}\n\t.st8{fill:#1A1A1A;stroke:#1A1A1A;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M778.6,1011.5L215.4,868.2c-13.7-3.5-22-17.5-18.5-31.2L390.2,76.9c3.5-13.7,17.5-22,31.2-18.5l563.2,143.3 c13.7,3.5,22,17.5,18.5,31.2L809.8,993C806.3,1006.7,792.3,1015,778.6,1011.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M419.3,827.1l-115.3-29.3c-3.5-0.9-5.6-4.5-4.7-8l81.9-322.1c0.9-3.5,4.5-5.6,8-4.7l115.3,29.3 c3.5,0.9,5.6,4.5,4.7,8l-81.9,322.1C426.4,825.9,422.8,828,419.3,827.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M870.2,448.8l-282.8-71.9c-1.4-0.3-2.2-1.7-1.8-3.1l4.6-18.2c0.3-1.4,1.7-2.2,3.1-1.8L876,425.7 c1.4,0.3,2.2,1.7,1.8,3.1l-4.6,18.2C872.9,448.3,871.5,449.1,870.2,448.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M855.7,505.5l-282.8-71.9c-1.4-0.3-2.2-1.7-1.8-3.1l4.6-18.2c0.3-1.4,1.7-2.2,3.1-1.8l282.8,71.9 c1.4,0.3,2.2,1.7,1.8,3.1l-4.6,18.2C858.5,505,857.1,505.8,855.7,505.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M841.3,562.2l-282.8-71.9c-1.4-0.3-2.2-1.7-1.8-3.1l4.6-18.2c0.3-1.4,1.7-2.2,3.1-1.8l282.8,71.9 c1.4,0.3,2.2,1.7,1.8,3.1l-4.6,18.2C844.1,561.7,842.7,562.5,841.3,562.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M826.9,618.9L544.1,547c-1.4-0.3-2.2-1.7-1.8-3.1l4.6-18.2c0.3-1.4,1.7-2.2,3.1-1.8l282.8,71.9 c1.4,0.3,2.2,1.7,1.8,3.1l-4.6,18.2C829.6,618.4,828.2,619.2,826.9,618.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M812.5,675.6l-282.8-71.9c-1.4-0.3-2.2-1.7-1.8-3.1l4.6-18.2c0.3-1.4,1.7-2.2,3.1-1.8l282.8,71.9 c1.4,0.3,2.2,1.7,1.8,3.1l-4.6,18.2C815.2,675.1,813.8,675.9,812.5,675.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M784.5,783.7L502.6,712c-1.6-0.4-2.6-2-2.2-3.6l17.5-68.8c0.4-1.6,2-2.6,3.6-2.2l281.9,71.7 c1.6,0.4,2.6,2,2.2,3.6l-17.5,68.8C787.7,783.1,786.1,784.1,784.5,783.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 661,
    cy: 288.4,
    r: 35.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 754.4,
    cy: 312.1,
    r: 35.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 847.8,
    cy: 335.9,
    r: 35.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M391,417.8l1-3.8c5.4,0.7,9.8-0.2,13.3-2.9c3.5-2.7,10.3-10.7,20.5-24.1l67.8-89.1l4.1,1L519,427.3 c1.4,8.5,2.9,13.9,4.5,16.2c1.6,2.3,4.6,4.4,9.2,6.3l-1,3.8L480,440.4l1-3.8c6.1,1,10.1,1.3,12,1c1.9-0.3,3.2-2,4-4.9 c0.3-1,0.4-2.8,0.3-5.5c0-2.7-0.3-5.6-0.8-8.6l-3.2-21.7l-53.7-13.6c-8.7,12-13.9,19.3-15.7,22c-1.8,2.7-2.9,4.9-3.3,6.6 c-0.9,3.4-0.1,6.2,2.4,8.2c1.5,1.2,4.6,2.6,9.3,4.3l-1,3.8L391,417.8z M492,387.8l-9.1-62l-37.7,50.1L492,387.8z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M835.3,1147H364.7c-10.1,0-18.3-8.2-18.3-18.3l0,0c0-10.1,8.2-18.3,18.3-18.3h470.7c10.1,0,18.3,8.2,18.3,18.3 l0,0C853.6,1138.8,845.4,1147,835.3,1147z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyportfoliodesigncopy07);
export default __webpack_public_path__ + "static/media/my portfolio design copy-07.9dd5113bd4bd29e2c0fcceb9b77e065b.svg";
export { ForwardRef as ReactComponent };